
export const VocabSocials = {
    connect_with_us : ['Conecta con nosotros', 'Connect with us'],
    name: ['Nombre', 'Name'],
    email: ['Email', 'Email'],
    message_tittle: ['Envianos un mensaje', 'Send us a message'],
    message: ['Mensaje', 'Message'],
    message_success: ['Mensaje enviado con exito!', 'Message sent successfully!'],
    socials_footer: ['Contigo de la mano', 'With you, every step of the way'],
  }
    